import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from 'src/app/core/services/app.service';
import { FocuslinkService } from 'src/app/core/services/focuslink.service';

@Component({
  selector: 'app-default',
  templateUrl: './default.component.html',
  styleUrls: ['./default.component.scss']
})
export class DefaultComponent implements OnInit {
  code: string;
  response: any;
  state: any;

  constructor(private focuslink: FocuslinkService, private route: ActivatedRoute, private router: Router) { }

  ngOnInit() {
    this.code = this.route.snapshot.queryParamMap.get('code');
    this.state = this.route.snapshot.queryParamMap.get('state');
    if (this.code && this.state) {
      this.state = atob(this.state);
      this.state = JSON.parse(this.state);
      this.getToken()
    }

    const action = this.route.snapshot.queryParamMap.get('action');
    if (action === 'getubertoken') {
      this.getUberToken();
    }
  }

  async getToken() {
    const payload = {
      code: this.code,
      appId: this.state.appId,
      venueKey: this.state.venueKey,
      redirectUri: this.state.redirectUri,
      grantType: this.state.grantType
    }
    this.response = await this.focuslink.oAuthToken(payload);
  }

  async getUberToken() {
    const payload = {
      appId: 'uber',
      grantType: 'client_credentials',
      scope: 'eats.store eats.order eats.store.status.write'
    }
    await this.focuslink.oAuthToken(payload);
  }

}
